<template>
  <a-modal v-if="isMobile" :open="show" @cancel="close">
    <template #title>
      <div :class="{'new': hasNew}" class="drawer-title">
        <div class="notification-title" v-if="!currentAction">
          <span>
            Уведомления
          </span>
          <div class="dot">{{ latestNotifications.newCount }}</div>
        </div>
        <div v-else class="sub-header">
          <div class="back-button-wrapper action-button-wrapper" @click="clearCurrentAction">
            <LeftOutlined class="back-button" />
          </div>
          <div>
            <span>{{ headerTranslate[currentAction] }}</span>
          </div>
        </div>
      </div>
    </template>

    <a-divider style="margin: 16px 0" />

    <div class="tabs" v-if="!currentAction">
      <a-tabs
          class="simple-green-tabs"
          :animated="false"
          v-model:activeKey="menuKey"
          @change="clearCurrentAction"
      >
        <a-tab-pane key="notifications" tab="Уведомления" />
        <a-tab-pane key="reminders" tab="Мои напоминания" />
      </a-tabs>
    </div>

    <div v-if="isPreloader" class="spinner">
      <a-spin />
    </div>
    <div v-else>
      <div v-if="!currentAction">
        <template v-if="menuKey === 'notifications'">
          <div v-if="!latestNotifications.notifications.length" class="grey-text empty-result">
            <span>Нет уведомлений</span>
          </div>

          <div class="notification-wrapper">
            <div v-for="noticeData in latestNotifications.notifications" :key="noticeData.date">
              <a-divider style="margin: 12px 0" orientation="left"><span class="date-header" :class="{'grey-text': !noticeData.created_today, 'recent': noticeData.created_today}">{{ noticeData.created_today ? 'Сегодня' : noticeData.date }}</span></a-divider>
              <div class="notice-card-list">
                <div v-for="notice in noticeData.items" :key="notice.send_at">
                  <a-card :bordered="notice.read" class="notice-card" :class="{'new-notice': !notice.read}">
                    <div class="notice-card-content">
                      <div> {{ notice.message }}</div>
                      <div v-if="!notice.read" class="read-button-wrapper">
                        <a-button class="secondary-button read-button" @click="readNotification(notice.id)">
                          Прочитать
                        </a-button>
                      </div>
                    </div>
                  </a-card>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="menuKey === 'reminders'">
          <div v-if="!latestNotifications.reminders.length" class="grey-text empty-result">
            <span>Нет напоминаний</span>
          </div>

          <div class="notification-wrapper">
            <div v-for="noticeData in latestNotifications.reminders" :key="noticeData.date">
              <a-divider style="margin: 12px 0" orientation="left"><span class="date-header" :class="{'grey-text': !noticeData.created_today, 'recent': noticeData.created_today}">{{ noticeData.created_today ? 'Сегодня' : noticeData.date }}</span></a-divider>
              <div class="notice-card-list">
                <div v-for="notice in noticeData.items" :key="notice.send_at">
                  <a-card class="notice-card">
                    <div class="notice-card-content">
                      <div> {{ notice.message }}</div>
                      <div v-if="!notice.sent" class="control-button-wrapper">
                        <a-button class="secondary-button control-button" @click="editReminder(notice)">
                          <EditOutlined />
                          <span v-if="isMobile">
                            Редактировать
                          </span>
                        </a-button>
                        <a-button class="secondary-button control-button" @click="deleteReminder(notice.id)">
                          <DeleteOutlined />
                          <span v-if="isMobile">
                            Удалить
                          </span>
                        </a-button>
                      </div>
                    </div>
                  </a-card>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>

      <template v-if="currentAction === 'settings'">
        <div class="setting-form">
          <a-card class="setting-card-block">
            <div class="setting-title">
              Приглашение пройти тестирование
            </div>
            <div class="settings-column">
              <template v-if="getRight('adminNotifications')">
                <div class="setting-group">
                  <div class="grey-text setting-label">Отправить оповещение сотруднику:</div>
                  <div class="setting-block">
                    <div class="setting-row">
                      <a-switch v-model:checked="settingsForm.notifyEmployee3Days" />
                      <div>Если он не прошел тест в течение 3-х дней</div>
                    </div>

                    <div class="setting-row">
                      <a-switch v-model:checked="settingsForm.notifyEmployee7Days" />
                      <div>Если он не прошел тест в течение недели</div>
                    </div>
                  </div>
                </div>
              </template>

              <div class="setting-group">
                <div class="grey-text setting-label">Отправить оповещение мне:</div>
                <div class="setting-block">
                  <template v-if="getRight('adminNotifications')">
                    <div class="setting-row">
                      <a-switch v-model:checked="settingsForm.notifyAdmin3Days" />
                      <div>Если сотрудник не прошел тест в течение 3-х дней</div>
                    </div>

                    <div class="setting-row">
                      <a-switch v-model:checked="settingsForm.notifyAdmin7Days" />
                      <div>Если сотрудник не прошел тест в течение недели</div>
                    </div>
                  </template>
                  <div class="setting-row">
                    <a-switch v-model:checked="settingsForm.notifySelf3Days" />
                    <div>Если тест не пройден в течение 3-х дней</div>
                  </div>

                  <div class="setting-row">
                    <a-switch v-model:checked="settingsForm.notifySelf7Days" />
                    <div>Если тест не пройден в течение недели</div>
                  </div>
                </div>
              </div>
            </div>
          </a-card>

          <a-card class="setting-card-block">
            <div class="settings-card">
              <div class="setting-title">
                Приглашение в ЛК
              </div>
              <div class="settings-column">
                <div class="setting-group">
                  <template v-if="getRight('adminNotifications')">
                    <div class="grey-text setting-label">Отправить оповещение сотруднику:</div>
                    <div class="setting-block">
                      <div class="setting-row">
                        <a-switch v-model:checked="settingsForm.notifyEmployeeCourseExpires" />
                        <div>За 14 дней до окончания доступа к курсу</div>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="setting-group">
                  <div class="grey-text setting-label">Отправить оповещение мне</div>
                  <div class="setting-block">
                    <div class="setting-row" v-if="getRight('adminNotifications')">
                      <a-switch v-model:checked="settingsForm.notifyAdminCourseExpires" />
                      <div>За 14 дней до окончания доступа сотрудника к курс</div>
                    </div>
                    <div class="setting-row">
                      <a-switch v-model:checked="settingsForm.notifySelfCourseExpires" />
                      <div>За 14 дней до окончания доступа к курсу</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-card>

          <a-alert show-icon message="Если у вас возникли вопросы, свяжитесь с нами." type="info" class="blue-alert">
            <template #icon>
              <InfoCircleFilled style="color: var(--main-blue)"/>
            </template>
          </a-alert>
        </div>
      </template>

      <template v-if="currentAction === 'reminder_form'">
        <a-form layout="vertical" @finish="handleAction" class="notice-form">

          <div style="display:flex; gap:16px">
            <a-form-item label="Дата">
              <a-date-picker
                  v-model:value="reminderForm.date"
                  format="DD.MM.YYYY"
                  class="date-picker-mobile"
                  :show-now="false"
                  :need-confirm="false"
              />
            </a-form-item>

            <a-form-item label="Время">
              <a-time-picker
                  v-model:value="reminderForm.time"
                  format="HH:mm"
                  class="time-picker-mobile"
                  :show-now="false"
                  :minute-step="5"
              />
            </a-form-item>
          </div>

          <a-form-item label="Текст напоминания">
            <a-textarea
                v-model:value="reminderForm.message"
                :rows="4"
            />
          </a-form-item>

          <a-form-item>
            <a-checkbox v-model:checked="reminderForm.send_to_email">
              Продублировать на мою почту
            </a-checkbox>
          </a-form-item>
        </a-form>
      </template>

      <template v-if="currentAction === 'edit_mail_templates'">
        <TemplateEditor ref="templateEditor" />
      </template>
    </div>

    <a-divider style="margin: 16px 0" />
    <template #footer>
      <template v-if="!currentAction">
        <div class="footer-button">
          <div class="footer-button-wrapper">
            <a-dropdown :trigger="['click']" placement="bottomLeft">
              <a-button class="secondary-button" @click.prevent>
                <SettingOutlined />
              </a-button>

              <template #overlay>
                <a-menu @click="({key}) => currentAction = key">
                  <a-menu-item key="settings">Настроить уведомления</a-menu-item>
                  <a-menu-item v-if="getRight('admin')" key="edit_mail_templates">Шаблоны почтовых писем</a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>

            <a-button
                class="secondary-button"
                @click="() => {
                  currentAction = 'reminder_form'
                }">
              <template #icon>
                <PlusOutlined />
              </template>
              <span v-if="!isMobile">
                Создать напоминание
              </span>
            </a-button>
          </div>

          <div class="read-all-button" v-if="latestNotifications.newCount">
            <a-button class="secondary-button" @click="readAllNotifications" :loading="actionLoading">
              Прочитать все
            </a-button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="footer-button mobile-footer">
          <div>
            <a-button class="secondary-button" @click="clearCurrentAction">
              Отменить
            </a-button>
          </div>
          <div>
            <a-button class="primary-button" @click="handleAction" :loading="actionLoading">
              Сохранить
            </a-button>
          </div>
        </div>
      </template>
    </template>
  </a-modal>
</template>

<script>
import { computed, onBeforeMount, ref } from "@vue/runtime-core";
import { useStore } from "vuex";
import {
  CloseOutlined, MoreOutlined, PlusOutlined, SettingOutlined, LeftOutlined, EditOutlined, DeleteOutlined,
  InfoCircleFilled
} from "@ant-design/icons-vue";

import Preloader from "../Technical/Preloader.vue";
import {onMounted} from "vue";
import {reactive} from "@vue/reactivity";
import useCheckRights from "@/mixins/useCheckRights";
import {message} from "ant-design-vue";
import dayjs from "dayjs";
import editOutlined from "@ant-design/icons-vue/lib/icons/EditOutlined";
import TemplateEditor from "@/components/Notification/TemplateEditor.vue";
export default {
  methods: {editOutlined},
  components: {
    TemplateEditor,
    InfoCircleFilled,
    MoreOutlined, PlusOutlined, Preloader, CloseOutlined, SettingOutlined, LeftOutlined, DeleteOutlined, EditOutlined },
  name: "mobile-notification",
  emits: ['close'],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const store = useStore();
    const latestNotifications = computed(
        () => store.state.notifications.latestNotifications
    );

    const {getRight} = useCheckRights();

    const isPreloader = ref(true);
    const hasNew = computed(() => latestNotifications.value.newCount);
    const menuKey = ref('notifications');
    const currentAction = ref('');
    const actionLoading = ref(false);

    const headerTranslate = {
      settings: 'Настройка уведомлений',
      reminder_form: 'Уведомление',
      edit_reminder: 'Редактирование напоминания',
      edit_mail_templates: 'Настройка шаблонов писем'
    }

    const isMobile = ref(window.innerWidth <= 768)

    const onResize = () => {
      isMobile.value = window.innerWidth <= 768
    }

    onMounted(() => {
      window.addEventListener('resize', onResize)
    });

    onBeforeMount(async () => {
      await store.dispatch("notifications/getOptionsLabels");
      await store.dispatch("notifications/getOptionsList");
      for (let option in optionsList.value) settingsForm[option] = optionsList.value[option];
      for (let option in optionsList.value) settingsForm[option] = optionsList.value[option];

      isPreloader.value = false;
    });

    const readNotification = (id) => {
      actionLoading.value = true;
      store.dispatch("notifications/readNotification", { id }).then(() => {
        fetchLatestNotifications();
        actionLoading.value = false;
      });
    };

    const fetchLatestNotifications = async () => {
      isPreloader.value = true;
      await store.dispatch("notifications/getReminders");

      store.dispatch("notifications/getLatest")
          .then(() => (isPreloader.value = false));
    }

    const readAllNotifications = () => {
      store.dispatch("notifications/readAllNotifications").then(() => {
        fetchLatestNotifications();
        actionLoading.value = false;
      });
    }

    const close = () => {
      context.emit('close');
    }

    let optionsList = computed(() => store.state.notifications.optionsList);

    let settingsForm = reactive({
      notifyEmployee3Days: false,
      notifyEmployee7Days: false,
      notifyAdmin3Days: false,
      notifyAdmin7Days: false,
      notifyAdminCourseExpires: false,
      notifyEmployeeCourseExpires: false,
      notifySelf3Days: false,
      notifySelf7Days: false,
      notifySelfCourseExpires: false,
    });

    const submitNotificationOptions = () => {
      actionLoading.value = true;
      store.dispatch("notifications/saveOptionsNotification", settingsForm).then(() => {
        message.success('Данные сохранены');
      }).finally(() => {
        actionLoading.value = false;
      });
    };

    let reminderForm = reactive({
      message: '',
      date: null,
      time: null,
      send_to_email: false,
    });

    const currentReminderToEdit = ref(null);

    const editReminder = (notice) => {
      currentReminderToEdit.value = notice;
      reminderForm.message = notice.message;
      reminderForm.send_to_email = notice.mail_sent ? false : true;

      const dt = dayjs(notice.send_at);
      reminderForm.date = dt;
      reminderForm.time = dt;

      currentAction.value = 'reminder_form';
    }

    const deleteReminder = (id) => {
      actionLoading.value = true;
      store.dispatch("notifications/deleteReminder", {id: id}).then(() => {
        message.success('Напоминание удалено');
        fetchLatestNotifications();
      }).finally(() => {
        actionLoading.value = false;
      });
    }

    const submitNoticeForm = () => {
      let sendAt = null

      if (!reminderForm.message || !reminderForm.date || !reminderForm.time) {
        message.info('Заполните все поля');
        return;
      }

      sendAt = dayjs(reminderForm.date)
          .hour(dayjs(reminderForm.time).hour())
          .minute(dayjs(reminderForm.time).minute())
          .second(0)
          .format('YYYY-MM-DD HH:mm:ss')

      const payload = {
        send_at: sendAt,
        message: reminderForm.message,
        send_email: reminderForm.send_to_email
      }

      if (currentReminderToEdit.value) {
        actionLoading.value = true;
        store.dispatch('notifications/editNotification', {
          id: currentReminderToEdit.value.id,
          ...payload
        }).then(() => {
          message.success('Данные сохранены')
          actionLoading.value = false;
          currentAction.value = null;
          fetchLatestNotifications();
        })
      } else {
        actionLoading.value = true;
        store.dispatch('notifications/createNotification', payload).then(() => {
          message.success('Данные сохранены')
          actionLoading.value = false;
          currentAction.value = null;
          fetchLatestNotifications();
          currentReminderToEdit.value = null;
        })
      }
    }

    const handleAction = () => {
      if (!currentAction.value) {
        return;
      }

      if (currentAction.value === 'settings') {
        submitNotificationOptions();
      }

      if (currentAction.value === 'reminder_form') {
        submitNoticeForm();
      }

      if (currentAction.value === 'edit_mail_templates') {
        saveEditedTemplates();
      }
    }

    const clearCurrentAction = () => {
      currentAction.value = null;
      currentReminderToEdit.value = null;

      Object.assign(reminderForm, {
        message: '',
        date: null,
        time: null,
        send_to_email: false,
      });
    }

    const templateEditor = ref()

    const saveEditedTemplates = () => {
      templateEditor.value.saveTemplates()
    }

    return {
      latestNotifications,
      isPreloader,
      readNotification,
      hasNew,
      close,
      menuKey,
      readAllNotifications,
      currentAction,
      isMobile,
      headerTranslate,
      submitNotificationOptions,
      settingsForm,
      actionLoading,
      getRight,
      handleAction,
      reminderForm,
      deleteReminder,
      editReminder,
      clearCurrentAction,
      templateEditor
    };
  },
};
</script>

<style lang="scss">

.notification-icon {
  width: 16px;
  height: 16px;
  cursor: pointer;
  padding: 0;
}

.notifications {
  .popper {
    -webkit-box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.11) !important;
    -moz-box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.11) !important;
    box-shadow: 0px 5px 10px 2px rgba(34, 60, 80, 0.11) !important;
    color: var(--common-text-color) !important;

    &:hover {
      color: var(--common-text-color) !important;
    }

    #arrow::before,
    #arrow:hover::before {
      -webkit-box-shadow: 0px 5px 10px -3px rgba(34, 60, 80, 0.2);
      -moz-box-shadow: 0px 5px 10px -3px rgba(34, 60, 80, 0.2);
      box-shadow: 0px 5px 10px -3px rgba(34, 60, 80, 0.2);
    }
  }
}
</style>
<style lang="scss" scoped>
.notifications {
  &__notification-btn {
    position: relative;
    color: rgba(0, 0, 0, 0.5);
    display: flex;

    &:hover {
      color: rgba(0, 0, 0, 0.75);
    }
  }
}

.notifications__notification-btn.new {
  color: white;
}

.dot {
  display: none;
  position: absolute;
  top: -10px;
  right: -23px;
  height: 20px;
  min-width: 25px;
  background-color: var(--color-error);
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 4px;
  border: 1px solid #FFFFFF;
  border-radius: 999px;
  font-size: 14px;
}

.new .dot {
  display: flex;
}

@media (max-width: 768px) {
  .notifications-body {
    width: 300px;
  }
}

.inline-block {
  margin: 0 !important;
  border: 0 !important;
}

.notification-title {
  width: fit-content;
  position: relative;
  display: flex;
  align-items: center;
  column-gap: 8px;

  .dot {
    position: unset;
    color: #FFFFFF;
  }
}

.close-icon {
  color: var(--grey-text);
  cursor: pointer;
}

.close-icon:hover {
  color: var(--main-font);
}

.drawer-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tabs {
  width: fit-content;

  :deep(.ant-tabs-nav-more) {
    display: none;
  }
}

.spinner {
  margin-top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: $mobile-breakpoint) {
    margin-top: 10%;
  }
}

.date-header {
  font-weight: 400;
  font-size: 14px;
  line-height: 110%;
}

:deep(.ant-tabs-top >.ant-tabs-nav) {
  margin-bottom: 0 !important;
}

.recent {
  font-weight: 600;
}

.notice-card {
  padding: 12px 16px !important;
  box-shadow: unset;

  :deep(.ant-card-body) {
    padding: 0 !important;
    font-weight: 400;
    font-size: 14px;
  }

  .read-button-wrapper {
    @media (max-width: $mobile-breakpoint) {
      width: 100%;
    }
  }

  .read-button {
    @media (max-width: $mobile-breakpoint) {
      width: 100%;
    }
  }

  .notice-card-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    @media (max-width: $mobile-breakpoint) {
      flex-direction: column;
      align-items: flex-start;

      .secondary-button {
        width: 100%;
      }
    }
  }
}

.new-notice {
  background-color: var(--polar-green);
}

:deep(.ant-tabs .ant-tabs-tab+.ant-tabs-tab) {
  margin-left: 16px !important;
}

.notice-card-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.footer-button,
.footer-button-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

.mobile-footer {
  flex-direction: column-reverse;

  button {
    width: 100%;
  }
}

.ant-dropdown-trigger.ant-dropdown-open {
  border-color: var(--main-green);
}

.empty-result {
  margin-top: 8px;
}

.sub-header {
  display: flex;
  column-gap: 12px;
  align-items: center;
}

.setting-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.settings-column {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.setting-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.setting-label {
  margin-bottom: 12px;
}

.setting-row {
  display: flex;
  column-gap: 8px;
  align-items: center;
}

.setting-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 120%;
  margin-bottom: 16px;
}

.setting-card-block {
  :deep(.ant-card-body) {
    padding: 16px !important;
  }
}

.action-button-wrapper {
  cursor: pointer;
}

.notice-form {
  :deep(.ant-form-item) {
    margin-bottom: 12px !important;
  }

  :deep(.ant-form-item-label) {
    padding-bottom: 4px;

    label {
      color: var(--grey-text);
    }
  }
}

.blue-alert {
  border: unset;
  border-radius: 6px;

  :deep(.ant-alert-message) {
    padding: 8px 0;
  }
}

.control-button,
.footer-button .secondary-button.ant-dropdown-trigger {
  padding: 3px 9px;
}

.control-button-wrapper {
  display: flex;
  column-gap: 4px;
}

.footer-button {
  :deep(.ant-btn) {
    margin-inline-start: unset !important;
  }
}
</style>